import { endPoints, API_ROOT } from "../../../appSettings";
import { adalApiFetch } from "../../../authProvider";
import { saveAs } from "file-saver";
import { UsageLimitType, getKeyByDisplayName, getKeyByValue } from "../../../constant";

export const GET_VOUCHERS = "GET_VOUCHERS";
export const ADD_VOUCHER = "ADD_VOUCHER";
export const UPDATE_VOUCHER = "UPDATE_VOUCHER";
export const DELETE_VOUCHER = "DELETE_VOUCHER";
export const EXPORT_VOUCHER = "EXPORT_VOUCHER";

export function getVouchers(
  page = 1,
  limit = 10,
  sortBy = 0,
  orderBy = 0,
  search = "",
  family = -1,
  packageName = "",
  productNumber = "",
  searchBy = 0,
  operation = 0
) {
  if (packageName === "-") {
    packageName = "";
  }

  if (productNumber === "-") {
    productNumber = "";
  }

  const url = `${API_ROOT}${endPoints.voucher}/list?page=${page}&limit=${limit}&sortBy=${sortBy}&orderBy=${orderBy}&searchText=${search}&unitFamilyId=${family}&packageName=${packageName}&productNumber=${productNumber}&searchBy=${searchBy}&operation=${operation}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return (dispatch) => {
    return adalApiFetch(fetch, url, options, dispatch)
      .then((response) =>
        response.json().then((json) => {
          if (!response.ok) {
            return Promise.reject(json);
          }

          dispatch({ type: GET_VOUCHERS, payload: json });
        })
      )
      .catch((error) => {
        throw Error(error);
      });
  };
}

export function exportVoucher(id, voucher) {
  const url = `${API_ROOT}${endPoints.entitlement}/voucher/${id}`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      quantity: voucher.quantity,
      valid_from: voucher.validFrom,
      valid_to: voucher.validTo,
      document_type: voucher.format,
      purpose: voucher.purpose,
      zip_password: voucher.zipPassword,
    }),
  };

  return (dispatch) => {
    return adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) =>
            dispatch({
              type: EXPORT_VOUCHER,
              isSuccess: false,
              payload: json,
            })
          );
        }
        return response.blob().then((blob) => {
          saveAs(blob, "Vouchers.zip");
          return dispatch({ type: EXPORT_VOUCHER, isSuccess: true });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
  };
}

const toBinaryValue = (value) => {
  const truthyValues = ["true", true, 1, "1"];
  return truthyValues.includes(value) ? 1 : 0;
};

const getVoucherPayload = (voucher, hasOverridePermission) => {
  let requiresLogin, requiresOnline, usageLimitType;

  if (hasOverridePermission) {
    requiresLogin = toBinaryValue(voucher.requiresLogin);
    requiresOnline = toBinaryValue(voucher.requiresOnline);
    const usageLimitTypeId = parseInt(voucher.usageLimitType);
    usageLimitType = getKeyByValue(UsageLimitType, usageLimitTypeId);
  } else {
    requiresLogin = voucher.requiresLogin;
    requiresOnline = voucher.requiresOnline;
    usageLimitType = getKeyByDisplayName(UsageLimitType, voucher.usageLimitType);
  }

  return {
    duration: voucher.duration,
    usage_limit: voucher.usageLimit,
    number_of_unlock: voucher.numberOfUnlock,
    requires_login: requiresLogin,
    requires_online: requiresOnline,
    usage_limit_type: usageLimitType,
  }
}

export function defineVoucher(voucher, hasOverridePermission) {
  const url = `${API_ROOT}${endPoints.voucher}`;
  const payload = getVoucherPayload(voucher, hasOverridePermission)
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      product_number: voucher.productNumber,
      ...payload
    }),
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: ADD_VOUCHER,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: ADD_VOUCHER,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
}

export function updateVoucher(id, voucher, hasOverridePermission) {
  const url = `${API_ROOT}${endPoints.voucher}/${id}`;
  const payload = getVoucherPayload(voucher, hasOverridePermission)
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_VOUCHER,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_VOUCHER,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
}

export function deleteVoucher(id) {
  const url = `${API_ROOT}${endPoints.voucher}/${id}`;
  const options = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: DELETE_VOUCHER,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: DELETE_VOUCHER,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
}

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.entitlement}${endPoints.voucher}${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};

export const getPackagesByFamilyId = (familyId) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.voucher}/filter/families/${familyId}/package-names`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};

export const getProductNumbersByFamilyPackageName = (familyId, packageName) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.voucher}/filter/families/${familyId}/package-names/${packageName}/product-numbers`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};
